import { ReactElement } from 'react';

import { PlanFeaturesTypes } from '~globals/types/enums';
import AccessFeature from '~components/AccessFeature';
import Subscription from '~components/Subscription';

import { useDashboardVariantV2CarrierContext } from '../../../Context';
import DashboardVariantV2CarrierContentCollectTabProvider, {
  useDashboardVariantV2CarrierContentCollectTabContext,
} from './Context';

import {
  DashboardVariantV2CarrierContentTabContainer,
  DashboardVariantV2CarrierContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2CarrierContentCollectTabActions,
  DashboardVariantV2CarrierContentCollectTabCurrenFilters,
  DashboardVariantV2CarrierContentCollectTabDataTable,
  DashboardVariantV2CarrierContentCollectTabTracking,
} from './Components';
import DashboardVariantV2CarrierZoneSaturation from '../../../ZoneSaturation';

const DashboardVariantV2CarrierContentCollectTab = (): ReactElement => {
  const {
    data: {
      zoneSaturation: {
        data: { zones },
      },
    },
  } = useDashboardVariantV2CarrierContext();

  const {
    showTracking: { value: showTracking },
  } = useDashboardVariantV2CarrierContentCollectTabContext();

  return (
    <DashboardVariantV2CarrierContentTabContainer>
      <DashboardVariantV2CarrierContentCollectTabActions />

      {zones.length > 0 && (
        <AccessFeature.Hidden
          validFeature={PlanFeaturesTypes.MgmZones}
          type="notAccess"
        >
          <DashboardVariantV2CarrierZoneSaturation />
        </AccessFeature.Hidden>
      )}

      {!showTracking && (
        <DashboardVariantV2CarrierContentCollectTabCurrenFilters />
      )}

      <div>
        <Subscription.AvailableRoutesState.Alert
          withButtons
          withCloseAction
          sx={(currentTheme) => ({
            padding: currentTheme.spacing(0, 2, 2, 2),
          })}
        />
      </div>

      <DashboardVariantV2CarrierContentWrapper>
        {!showTracking && (
          <DashboardVariantV2CarrierContentCollectTabDataTable />
        )}

        {showTracking && <DashboardVariantV2CarrierContentCollectTabTracking />}
      </DashboardVariantV2CarrierContentWrapper>
    </DashboardVariantV2CarrierContentTabContainer>
  );
};

const DashboardVariantV2CarrierContentCollectTabWrapper = (): ReactElement => (
  <DashboardVariantV2CarrierContentCollectTabProvider>
    <DashboardVariantV2CarrierContentCollectTab />
  </DashboardVariantV2CarrierContentCollectTabProvider>
);

export default DashboardVariantV2CarrierContentCollectTabWrapper;
